import PropTypes from 'prop-types'
import { Flex } from 'reflexbox/styled-components'
import styled from 'styled-components'

import { PLAN_MAKER, PRICING_PLANS } from '@anvilco-pkg/sanity'
import IconCheck from '@anvilco-pkg/ui/components/Icon/IconCheck'
import IconInfo from '@anvilco-pkg/ui/components/Icon/IconInfo'
import Tooltip from '@anvilco-pkg/ui/components/Tooltip'

import { MAKER_TOOL_TIP, CUSTOM_TOOL_TIP } from 'consts'

import theme from 'theme'
import media from 'media'

const SORTED_PLANS = PRICING_PLANS.reverse()

const FilterContainer = styled(Flex)
  .attrs({
    mb: 32,
    alignItems: 'center',
    justifyContent: ['flex-start', 'center'],
  })
  .withConfig({
    shouldForwardProp: (prop) => ['alignLeft'].indexOf(prop) === -1,
  })`
    gap: 8px;
    justify-content: flex-start;

    ${media.tablet`
      justify-content: ${({ alignLeft }) => (alignLeft ? 'flex-start' : 'center')};
    `}
`

const PlanSelector = styled(Flex)
  .attrs({
    as: 'button',
    alignItems: 'center',
    px: 8,
    height: 26,
    fontSize: 12,
    lineHeight: 1,
    py: 0,
    color: theme.colors.black,
  })
  .withConfig({
    shouldForwardProp: (prop) => ['isActive', 'isPrimary'].indexOf(prop) === -1,
  })`
  gap: 6px;
  border: 1px solid ${({ isActive, isPrimary }) => (isPrimary ? theme.colors.black : isActive ? theme.colors.black : theme.colors.blacks[40])};
  cursor: pointer;
  background: ${({ isActive, isPrimary }) => (isActive ? (isPrimary ? theme.colors.greens[20] : theme.colors.white) : 'transparent')};
  border-radius: 100px;
  transition: all 0.2s;
  font-weight: ${({ isActive }) => (isActive ? theme.fontWeights.black : theme.fontWeights.normal)};
  color: ${({ isActive, isPrimary }) => (isPrimary ? 'inherit' : isActive ? theme.colors.black : theme.colors.blacks[40])};
`

const PlansSelector = ({
  alignLeft,
  onChangePlan,
  activePlan,
  isPrimary = false,
}) => {
  return (
    <FilterContainer alignLeft={alignLeft}>
      Show:
      {SORTED_PLANS.map(({ key, value }) => (
        <PlanSelector
          key={key}
          onClick={() => onChangePlan(key)}
          isActive={key === activePlan}
          isPrimary={isPrimary}
        >
          {key === activePlan && (
            <IconCheck width={8} height={8} fill={theme.colors.greens[50]} />
          )}
          {value}
          <Tooltip
            placement="top"
            trigger="hover"
            title={key === PLAN_MAKER ? MAKER_TOOL_TIP : CUSTOM_TOOL_TIP}
          >
            <IconInfo width={10} height={10} fill={theme.colors.blacks[40]} />
          </Tooltip>
        </PlanSelector>
      ))}
    </FilterContainer>
  )
}

PlansSelector.propTypes = {
  onChangePlan: PropTypes.func,
  alignLeft: PropTypes.bool,
  activePlan: PropTypes.string,
  isPrimary: PropTypes.bool,
}

export default PlansSelector
